import {
	style,
	transition,
	animate,
	trigger,
} from '@angular/animations';

export const MeetingsAuthAnimation = [
	trigger('formAnimation', [
		transition(':enter', [
			style({ transform: 'translateX(50px)' }),
			animate('300ms ease-out'),
		]),
	]),
];
